"use strict";

var _regeneratorRuntime = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(generateRange);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateRange = void 0;

var range = function range(start, end, step) {
  return Array.from({
    length: Math.ceil((end - start) / step)
  }, function (_, i) {
    return start + i * step;
  });
};
/**
 * Return a generator yielding a sequence of numbers from [start, maximum).
 *
 * @param {IGenerateRange}  - options
 *
 * @returns {Generator<number>} - delaySeconds
 *
 */


function generateRange(_ref) {
  var _ref$start, start, stop, _ref$step, step, _ref$cycle, cycle, values, _iterator, _step, value;

  return _regeneratorRuntime.wrap(function generateRange$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, stop = _ref.stop, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step, _ref$cycle = _ref.cycle, cycle = _ref$cycle === void 0 ? false : _ref$cycle;
          values = range(start, stop, step);

          if (!(values.length < 1)) {
            _context.next = 4;
            break;
          }

          return _context.abrupt("return");

        case 4:
          if (!true) {
            _context.next = 26;
            break;
          }

          _iterator = _createForOfIteratorHelper(values);
          _context.prev = 6;

          _iterator.s();

        case 8:
          if ((_step = _iterator.n()).done) {
            _context.next = 14;
            break;
          }

          value = _step.value;
          _context.next = 12;
          return value;

        case 12:
          _context.next = 8;
          break;

        case 14:
          _context.next = 19;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](6);

          _iterator.e(_context.t0);

        case 19:
          _context.prev = 19;

          _iterator.f();

          return _context.finish(19);

        case 22:
          if (cycle) {
            _context.next = 24;
            break;
          }

          return _context.abrupt("return");

        case 24:
          _context.next = 4;
          break;

        case 26:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[6, 16, 19, 22]]);
}

exports.generateRange = generateRange;